import { render, staticRenderFns } from "./Oil.vue?vue&type=template&id=c55dad96"
import script from "./Oil.vue?vue&type=script&lang=js"
export * from "./Oil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports